import {DDay} from "../DDay";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers} from "./DDayLayers";
import {TimelineLite, Power2} from "gsap";
import {DDayGameConfig} from "../DDayGameConfig";
import {BlitzKriegReelView} from "../reels/BlitzKriegReelView";
import {GameHelper} from "../../core/utils/GameHelper";
import {BlitzKriegSound} from "../sound/BlitzKriegSound";

export class DDayAtomicWildFeatureView extends PIXI.Container {
    private _effect: PIXI.spine.Spine;
    private _gfx: PIXI.Graphics;

    constructor() {
        super();
        NolimitApplication.getLayerByName(Layers.ATOMIC_WILD)!.addChild(this);
    }

    private init(): void {
        this._effect = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("atomicWild"));
        this._effect.position.set(360, 360);
        this._effect.scale.set(1, 1);
        this._effect.visible = false;
        this._gfx = new PIXI.Graphics();
        this._gfx.beginFill(0x000000, 0.7);
        this._gfx.drawRect(NolimitApplication.screenBounds.left - 600, NolimitApplication.screenBounds.top - 300, 3 * NolimitApplication.screenBounds.width, 3 * NolimitApplication.screenBounds.height);
        this.addChild(this._gfx, this._effect);
    }

    public remove(): void {
        this.removeChild(this._effect);
        this.removeChild(this._gfx);
        this._effect.destroy();
        this._gfx.destroy();
    }

    public play(isNormalMode: boolean = false): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        this.init();
        let multiplier: number | undefined = DDay.model.parsedGameData.featureInfo[0]!.multiplier;
        if (multiplier) {
            let animName: string = "W" + DDay.commonService.getAtomicWildIndex(multiplier) + "_intro";
            let durr: number = this._effect.spineData.findAnimation(animName).duration;
            tl.add(() => {
                this._effect.visible = true;
                this._effect.state.setAnimation(0, animName, false).timeScale = 0.7;
                BlitzKriegSound.playTrack({name: BlitzKriegSound.RADIO_SIGNAL_SOUND});
            });
            tl.to(this, {
                duration: durr
            });
            tl.add(this.playFinalAtomicTransition());
        }
        return tl;
    }

    public playFinalAtomicTransition() {
        let tl: TimelineLite = new TimelineLite();
        let featureInfo = DDay.model.parsedGameData.featureInfo[0].coordinates;
        if (featureInfo) {
            let targetPosition: PIXI.Point = new PIXI.Point(BlitzKriegReelView.REEL_AREAS[featureInfo[0]].x, BlitzKriegReelView.REEL_AREAS[featureInfo[0]].y + (118 * featureInfo[1]));
            tl.add(() => {
                BlitzKriegSound.playTrack({name: "featureAtomicwildMove"});
            }, "effect");
            tl.to(this._effect, {
                x: targetPosition.x,
                y: targetPosition.y + 59,
                duration: 0.3,
                ease: Power2.easeInOut
            }, "effect");
            tl.to(this._effect.scale, {
                x: 0.8,
                y: 0.8,
                duration: 0.3
            }, "effect");
            tl.addLabel("effect");
        }
        return tl;
    }

    public playSettledAnim(): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            let position: PIXI.Point = this._effect.position;
            GameHelper.resetSpine(this._effect, true);
            this.removeChild(this._effect);
            this._effect = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("Wild"));
            let multiplier: number | undefined = DDay.model.parsedGameData.featureInfo[0]!.multiplier;
            if (multiplier) {
                let animName: string = "W" + DDay.commonService.getAtomicWildIndex(multiplier) + "_settle";
                this._effect.state.setAnimation(0, animName, true);
                BlitzKriegSound.playTrack({name: "featureAtomicwildLand"});
                this._effect.position = position;
                this.addChild(this._effect);
            }
        });
        tl.to(this, {duration: 0.5});
        return tl;
    }

    getRandomInt(min: number, max: number) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
